import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StorefrontIcon(props: IconProps) {
    return <Icon {...props} iconKey={"storefront"}/>
}
